import { round } from 'utils/math';

export const calculateVATRate = (
  VATAmount: number,
  amountInclVAT: number,
): number =>
  !amountInclVAT ? 0 : round(VATAmount / (amountInclVAT - VATAmount));

export const calculateVATAmount = (
  newAmountInclVAT: number,
  VATRate: number,
  options?: {
    roundResult?: boolean;
  },
) => {
  const _roundResult = options?.roundResult ?? true;
  if (!newAmountInclVAT) return 0;
  const result = newAmountInclVAT - newAmountInclVAT / (1 + VATRate);
  return _roundResult ? round(result) : result;
};

export const calcEndOfAmortizationPeriod = (
  date: string,
  amortizationPeriod: number | undefined,
) => {
  if (typeof amortizationPeriod !== 'number' || amortizationPeriod === 0) {
    return 0;
  }

  return new Date(date).getFullYear() + amortizationPeriod / 12;
};
